<template>
    <div id="admin_excluded_events_page" class="container-fluid">
        <h4 class="margin-left10 margin-bottom20 pull-left">Client: {{ client.name || 'All Clients' }}</h4>
        <button @click="resetModalData" type="button" class="btn btn-secondary main-button pull-right" data-toggle="modal" data-target="#add_new_event">+ Add New Event</button>

        <div class="modal fade" id="add_new_event" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Add New Event</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <input id="new_event" v-model="new_event" type="text" class="form-control">
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn" data-dismiss="modal">Cancel</button>
                        <button @click="addNewEvent" :disabled="!new_event" type="button" class="btn btn-success">Add</button>
                    </div>
                </div>
            </div>
        </div>

        <v-client-table :data="tableData" :columns="columns" :options="options">
            <div slot="excluded_event" slot-scope="props">
                <div v-if="!props.row.edit_mode">{{ props.row.excluded_event }}</div>
                <input v-if="props.row.edit_mode" type="text" class="form-control edit-excluded-event" :value="props.row.excluded_event">
            </div>

            <div slot="actions" slot-scope="props" class="text-right">
                <button v-if="!props.row.edit_mode" @click="toggleEditMode(props.row.id)" class="btn btn-info reverse">Edit</button>
                <button v-if="props.row.edit_mode" @click="save(props.row.id, $event)" class="btn btn-success reverse">Save</button>
                <button v-if="props.row.edit_mode" @click="toggleEditMode(props.row.id)" class="btn cancel-editing">Cancel</button>
                <button v-if="!props.row.edit_mode" @click="remove(props.row.id)" class="btn btn-danger reverse">Delete</button>
            </div>
        </v-client-table>

        <div class="text-center">
            <button @click="$router.go(-1)" type="button" class="btn btn-info">Back</button>
        </div>
    </div>
</template>

<script>
    export default {
        created() {
            if (this.$route.params.id) {
                axios.get(`/api/clients/${this.$route.params.id}`).then(response => {
                    this.client = response.data;
                });
            }

            this.fetchServerData();
        },

        data() {
            return {
                client: {},
                new_event: '',
                columns: ['excluded_event', 'actions'],
                tableData: [],
                options: {
                    headings: {
                        excluded_event: 'Excluded Events',
                        actions:              ''
                    },
                    sortable: ['excluded_event'],

                    perPage: 20,
                    perPageValues: [],
                    texts: {
                        count: 'Showing {from} to {to} of {count} events|{count} events|One event',
                        filter: '',
                        filterPlaceholder: 'Search events...',
                        noResults: 'No matching events'
                    },
                    skin: 'table'
                }
            }
        },

        methods: {
            fetchServerData() {
                axios.all([
                    axios.get(`/api/admin/excluded-events?client_id=${this.$route.params.id || ''}`)
                ])
                .then(axios.spread(excludedEvents => {
                    _.each(excludedEvents.data, item => {
                        item.edit_mode = false;
                    });

                    this.tableData = excludedEvents.data;
                }));
            },

            resetModalData() {
                this.new_event = '';
            },

            addNewEvent() {
                $('#add_new_event').modal('hide');

                axios.post(`/api/admin/excluded-events?client_id=${this.$route.params.id || ''}`, {
                    event: this.new_event
                }).then(() => {
                    this.$notify({
                        type: 'success',
                        text: 'Event has been successfully added.'
                    });

                    this.fetchServerData();
                });
            },

            toggleEditMode(id) {
                const index = _.findIndex(this.tableData, {id: id});

                if (index > -1) {
                    this.tableData[index].edit_mode = !this.tableData[index].edit_mode;
                }
            },

            save(id, event) {
                const newEvent = $(event.target).closest('tr').find('.edit-excluded-event').val();
                const index        = _.findIndex(this.tableData, {id: id});

                if (index > -1) {
                    this.tableData[index].edit_mode = false;
                }

                axios.put(`/api/admin/excluded-events/${id}?client_id=${this.$route.params.id || ''}`, {
                    event: newEvent
                }).then(() => {
                    this.$notify({
                        type: 'success',
                        text: 'Event has been successfully updated.'
                    });

                    this.fetchServerData();
                });
            },

            remove(id) {
                this.confirmation('Are you sure you want to delete this event?', () => {
                    axios.delete(`/api/admin/excluded-events/${id}?client_id=${this.$route.params.id || ''}`).then(() => {
                        this.$notify({
                            type: 'success',
                            text: 'Event has been successfully deleted.'
                        });

                        this.fetchServerData();
                    });
                });
            }
        }
    }
</script>

<style lang="scss">
    #admin_excluded_events_page {
        .edit-excluded-event {
            width: auto;
            height: 3.4rem;
        }

        .cancel-editing {
            padding: 0.8rem 1.65rem;
        }

        input[type="radio"] {
            position: relative;
            top: .1rem;
        }

        .VueTables__search {
            display: none;
        }

        .VueTables__table {
            table-layout: fixed;
        }
    }
</style>
